import React from "react";
import styles from "./Profile.module.css";

export function Profile({ step }) {
  const classes = Array.from(Array(+step + 1).keys())
    .map((s) => `${styles[`profile${s}`]}`)
    .join(" ");

  console.log(Array.from(Array(+step).keys()));

  //   const classes = styles.profile1;
  return (
    <div className={`${classes} ${styles.profile}`}>
      <p>8</p>
      {/* <p>{step}</p>
      <p>{classes}</p> */}
    </div>
  );
}
